import { useContext, useEffect, useState } from 'react';
import { AppState } from '../context/general';
import type { OfflineMode } from '../connector/feed-engine';

// Live offline state of the current feed engine. 'none' while online; the anonymous engine
// never reports anything else (it has no server session to lose).
export function useOfflineMode(): OfflineMode {
  const { feedEngine } = useContext(AppState);
  const [mode, setMode] = useState<OfflineMode>(() => feedEngine.getOfflineMode());
  useEffect(() => {
    // Re-read on engine swap (login/logout replaces the instance): the callback only fires
    // on changes, so a mode set before we subscribed would never reach this component.
    setMode(feedEngine.getOfflineMode());
    return feedEngine.onOfflineChange(setMode);
  }, [feedEngine]);
  return mode;
}
